import {combineReducers} from 'redux';
import {getUsersReducer} from './getUsers'
import {customerFileReducer } from './customerFileRed';
const reducer = combineReducers({
   customerFileReducer,getUsersReducer 
    });
    
    export default reducer;
